import * as React from "react";
import { Platform, Linking } from "react-native";
import { IconButton, Button } from "react-native-paper";
import * as WebBrowser from "expo-web-browser";
import { useAuth } from "../contexts/auth";

// Get API URL from environment variables (injected at build time by webpack)
const BITDROP_API = process.env.BITDROP_API || 'http://localhost:3000';

export default function AuthButton() {
  const { signOut, isAuthenticated } = useAuth();

  const signIn = async () => {
    const platform = Platform.select({ web: "web", default: "mobile" });
    if (platform == "web") {
      Linking.openURL(`${BITDROP_API}/auth/google?platform=${platform}`);
    } else {
      WebBrowser.openBrowserAsync(
        `${BITDROP_API}/auth/google?platform=${platform}`
      );
    }
  };

  return isAuthenticated() ? (
    <IconButton onPress={() => signOut()} icon="logout" />
  ) : (
    <Button onPress={() => signIn()}>Sign In</Button>
  );
}
